<div class="pack-container flex flex-col p-2.5">
  <span class="title">Productos que componen el pack:</span>

  <div class="flex flex-col gap-2.5">
    <div
      *ngFor="let product of products"
      class="product-card flex flex-col items-end justify-between md:flex-row md:items-center"
    >
      <div class="img-title flex w-full flex-row items-center md:w-fit">
        <img [src]="product.pictureUrl" alt="" />
        <span class="product-name">{{ product.title }}</span>
      </div>

      <span class="product-price">{{ product.unitPrice.amt | currency }} (x{{ getQty(product) }})</span>
    </div>
  </div>
</div>
